import type { DateTimeContextProps } from '@rtkwlf/fenrir-react';
import type { ScanQueue, ScanQueueRowsInner } from '@rtkwlf/rendall';

import { getDateTimeByTz } from '../../../../../../../../../utils/get-date-time-by-tz';

interface ScanQueueRowData extends ScanQueueRowsInner {
  tzLastScan: string;
}

export const getScanQueueSchedule = (
  data: ScanQueue,
  timezone: DateTimeContextProps['timezone'],
): ScanQueueRowData[] => {
  const scanningSchedule = data.rows.map((row) => {
    const tzLastScan = row.lastScan
      ? getDateTimeByTz(row.lastScan, timezone)
      : '';

    return {
      ...row,
      tzLastScan,
    };
  });

  return scanningSchedule;
};
